module.exports = __webpack_public_path__ + "img/emailsent.9cb27b22.png";